import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export const CALENDLY_DEMO_URL = 'https://calendly.com/alok-fashdeck/new-meeting';

/**
 * Inline Calendly booking modal for "Book a Demo".
 */
const CalendlyDemoModal = ({ isOpen, onClose, url = CALENDLY_DEMO_URL }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const embedSrc = `${url}${url.includes('?') ? '&' : '?'}hide_gdpr_banner=1`;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center bg-black/70 backdrop-blur-sm p-0 sm:p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Book a demo"
    >
      <div
        className="relative flex h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-t-2xl bg-white shadow-2xl sm:h-[min(860px,90vh)] sm:rounded-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-3 sm:px-5">
          <div>
            <p className="text-sm font-semibold text-gray-900">Book a Demo</p>
            <p className="text-xs text-gray-500">Pick a time that works for you</p>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline text-xs font-medium text-[#5424e4] hover:underline"
            >
              Open in new tab
            </a>
            <button
              type="button"
              onClick={onClose}
              className="rounded-full p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800"
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>
        </div>

        <iframe
          title="Book a Fashdeck demo on Calendly"
          src={embedSrc}
          className="h-full w-full flex-1 border-0 bg-white"
          loading="lazy"
          allow="camera; microphone; fullscreen"
        />
      </div>
    </div>
  );
};

export default CalendlyDemoModal;
